import { startCADItem } from '../../../services/ConnectionForge'
import { useContext } from 'react'
import { selectionDataContext } from '../../../hooks/context/SelectionDataContext'
import oc_config_data from './OCConfig-ExportData.json';

const ExportLayerVM = async (divElement) => {
    const destroy = ()=>{
    }
    return {destroy}
}

export default ExportLayerVM;

export function onCADSubmit(data: any, task:any, conectionId: any): void{
    const formData = new FormData()
    formData.append('data', JSON.stringify({
        dwgType: "Generic",
        taskName: task,
        browerConnectionId: conectionId,
        gisMetadata: data
    }));
    startCADItem(formData).then(
        response => {
        },
        error => {
           console.error('Error:', error)        }
    )
  };

export const getCADData = (payload) => {
   const siteDataArray = []
   let count_site = 0

   // Read Config file
   const gisConfigFeatureLayers = oc_config_data.parcelFabric_layers;

   payload.forEach(results => {
      let gisConfigFLObj;
      if(gisConfigFeatureLayers.hasOwnProperty(results.features[0].parentCustomParameters.OCLandInsightsID)){
         gisConfigFLObj = gisConfigFeatureLayers[results.features[0].parentCustomParameters.OCLandInsightsID]
      }
      else{
         gisConfigFLObj = gisConfigFeatureLayers["DefaultConfigObject"]
      }

      const agg_data = aggGISData(results, gisConfigFLObj)
      // check if we were able to aggregate data
      if(Object.keys(agg_data).length !== 0 ){

         if(results.geometryType === "multipoint"){
            count_site += 1
            const siteData = {
               OID_Site: count_site,
               Site_Name: results.layerName,
               Site_Description: results.layerName + " Description",
               Map_Type: results.layerName.replaceAll(' ', ''),
               GISPoints:agg_data
            }
            siteDataArray.push(siteData)
         }
         if(results.geometryType === "polygon"){
            count_site += 1
            const siteData = {
               OID_Site: count_site,
               Site_Name: results.layerName,
               Site_Description: results.layerName + " Description",
               Map_Type: results.layerName.replaceAll(' ', ''),
               GISPolygons:agg_data
            }
            siteDataArray.push(siteData)
         }
         if(results.geometryType === "polyline"){
            count_site += 1
            const siteData = {
               OID_Site: count_site,
               Site_Name: results.layerName,
               Site_Description: results.layerName + " Description",
               Map_Type: results.layerName.replaceAll(' ', ''),
               GISPolylines:agg_data
            }
            siteDataArray.push(siteData)
         }
      }
    })

    return siteDataArray
}

// export const getCADDataOld = async (view) => {
   
//    const siteDataArray = []
//    let count_site = 0
//    const parcelQuery = {

//       spatialRelationship: "intersects",
//       geometry: view.extent,
//       outFields: ["*"],
//       returnGeometry: true
//      };

//      await Promise.all(view.map.allLayers.map(async (layer) => {
//       if (layer.type === "feature" && layer.visible) {
//          await layer.queryFeatures(parcelQuery).then((results) =>{
//             if(results.features.length !== 0){
//                const agg_data = aggParcelGISData(results, layer.title)
//                // check if we were able to aggregate data
//                if(Object.keys(agg_data).length !== 0 ){
//                   count_site += 1
//                   const siteData = {
//                      OID_Site: count_site,
//                      Site_Name: layer.title,
//                      Site_Description: layer.title + " Description",
//                      Map_Type: layer.title,
//                      Parcels:agg_data
//                   }
//                   siteDataArray.push(siteData)
//                }
//             }
//          }).catch(errorCallback);
//       }
//     }));
//     return siteDataArray
// }

// const errorCallback = (error) => {
// }

const aggGISData = (gisdata, configObj) => {

   const gisObjs = {}
   let count_gisDataObj = 0;
   gisdata.features.forEach((item) => {
      if(item.geometry !== null){
         if(item.geometry.rings){
            const gisDataObj = {}
            count_gisDataObj += 1
            gisDataObj["HasMValues"] = false
            gisDataObj["HasZValues"] = false
            gisDataObj["HasCADLabel"] =  configObj.hasCadLabel
            gisDataObj["CADLabel"] = item.attributes[configObj.gisAttFieldLabel]
            gisDataObj["Geometry"] = item.geometry.rings
            gisDataObj["GIS_MetaData"] = item.attributes
     
            gisObjs[count_gisDataObj] = gisDataObj
         }
         if(item.geometry.paths){
            const gisDataObj = {}
            count_gisDataObj += 1
            gisDataObj["HasMValues"] = false
            gisDataObj["HasZValues"] = false
            gisDataObj["HasCADLabel"] =  configObj.hasCadLabel
            gisDataObj["CADLabel"] = item.attributes[configObj.gisAttFieldLabel]
            gisDataObj["Geometry"] = item.geometry.paths
            gisDataObj["GIS_MetaData"] = item.attributes
     
            gisObjs[count_gisDataObj] = gisDataObj
         }
         if(item.geometry.points){
            const gisDataObj = {}
            count_gisDataObj += 1
            gisDataObj["HasMValues"] = false
            gisDataObj["HasZValues"] = false
            gisDataObj["HasCADLabel"] =  configObj.hasCadLabel
            gisDataObj["CADLabel"] = item.attributes[configObj.gisAttFieldLabel]
            gisDataObj["Geometry"] = item.geometry.points
            gisDataObj["GIS_MetaData"] = item.attributes
     
            gisObjs[count_gisDataObj] = gisDataObj
         }
      }
  });
  return gisObjs
}

export const useCADDataHook = () => {
   const selectionDataCtx:any = useContext(selectionDataContext)
   const payload=selectionDataCtx.data
   return payload
}